module.exports = __webpack_public_path__ + "img/1.c0b44d24.png";